import { createElement } from "react";
import toast from "react-hot-toast";
import { UndoToast } from "../../components/common/UndoToast/UndoToast";

export const getSuccessToast = (message?: string | null) => {
  if (!message) {
    return;
  }

  return toast.success(message, {
    style: {
      background: "#3d0f0f",
      borderRadius: "10px",
      color: "#fff",
    },
  });
};

export const getErrorToast = (message?: string | null, width?: number) => {
  if (!message) {
    return;
  }

  return toast.error(message, {
    style: {
      background: "#3d0f0f",
      borderRadius: "10px",
      color: "#fff",
      width,
    },
  });
};

/**
 * Neutral explanation ("this is on purpose"), not an error. Pass an `id` so repeated
 * clicks refresh one toast instead of stacking a new one each time.
 */
export const getInfoToast = (message?: string | null, id?: string) => {
  if (!message) {
    return;
  }

  return toast(message, {
    id,
    icon: "🔒",
    style: {
      background: "#2a2340",
      borderRadius: "10px",
      color: "#fff",
    },
  });
};

/** Celebration toast for a freshly earned personal-record badge. */
export const getAchievementToast = (message?: string | null) => {
  if (!message) {
    return;
  }

  return toast(message, {
    icon: "🏆",
    duration: 5000,
    style: {
      background: "#2a2340",
      border: "1px solid rgba(252, 225, 115, 0.45)",
      borderRadius: "12px",
      color: "#fff",
      fontWeight: 600,
    },
  });
};

/**
 * A toast with one action that takes a one-tap change back (e.g. a quick arrival). The
 * action closes the toast before it runs, so it can't be pressed twice.
 */
export const getUndoToast = (
  message: string,
  onUndo: () => void,
  undoLabel = "Отмени",
) => {
  return toast.custom(
    (t) =>
      createElement(UndoToast, {
        message,
        undoLabel,
        onUndo: () => {
          toast.dismiss(t.id);
          onUndo();
        },
      }),
    { duration: 6000 },
  );
};
